import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/authStore';
import { useSetupConfig } from '../api/useSetupConfig';
import { SetupWizard } from './SetupWizard';

interface SetupWizardGuardProps {
  children: React.ReactNode;
}

export function SetupWizardGuard({ children }: SetupWizardGuardProps) {
  const user = useAuthStore(s => s.user);
  const [wizardClosed, setWizardClosed] = useState(false);

  const { data: setupConfig } = useSetupConfig();

  const isAdmin = user?.role === 'ADMIN';
  const setupNotCompleted = setupConfig?.setupCompleted === false;
  const shouldShowWizard = isAdmin && setupNotCompleted && !wizardClosed;

  return (
    <>
      {children}
      <SetupWizard
        open={shouldShowWizard}
        onClose={() => setWizardClosed(true)}
      />
    </>
  );
}
